import { REQUEST_FACEBOOK_POST_SUCCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function publishFbPostsList(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_FACEBOOK_POST_SUCCCESS:
      
     
      return { ...state, posts: action.payload.data.data.posts, errors: null }
    default:
      return state;
  }
}
